<template>
  <div class="checklist-editor-tabs">
    <div
      class="tab"
      :class="{
        active: tab.key === value,
      }"
      v-for="tab in tabs"
      @click="$emit('input', tab.key)"
      :key="tab.key"
    >
      <div class="qrw-label-lg" :class="{ bold: tab.key === value }">
        {{ tab.text }}
      </div>
      <div class="tab-line" v-if="tab.key === value"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    tabs: Array,
  },
};
</script>

<style scoped>
.checklist-editor-tabs {
  display: flex;
  padding: 0 52px;
  width: 100%;
  box-sizing: border-box;
  column-gap: 24px;
}

.tab {
  color: var(--qrw-content-base-tertiary);
  display: flex;
  padding-top: 8px;
  row-gap: 6px;
  cursor: pointer;
  flex-direction: column;
}

.tab.active {
  color: var(--qrw-content-base-primary);
}

.tab-line {
  width: 100%;
  height: 2px;
  background: var(--qrw-border-base-primary);
  display: flex;
}
</style>